<template>
  <div 
    v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
    ref="bienvenidaRef"
    class="bienvenida-overlay"
  >
    <div class="decoraciones-laterales" aria-hidden="true">
      <img ref="decoracionLazoRef" src="@/assets/lazo.avif" class="deco-item lateral-lazo" alt="Lazo" />
      <img ref="decoracionCora1Ref" src="@/assets/cora.avif" class="deco-item lateral-cora-1" alt="Corazón" />
      <img ref="decoracionEstre1Ref" src="@/assets/estre.png" class="deco-item lateral-estre-1" alt="Estrella" />
      <img ref="decoracionBola1Ref" src="@/assets/bola.avif" class="deco-item lateral-bola-1" alt="Bola" />

      <img ref="decoracionCora2Ref" src="@/assets/cora.avif" class="deco-item lateral-cora-2" alt="Corazón" />
      <img ref="decoracionEstre2Ref" src="@/assets/estre.png" class="deco-item lateral-estre-2" alt="Estrella" />
      <img ref="decoracionEstre3Ref" src="@/assets/estre.png" class="deco-item lateral-estre-3" alt="Estrella" />
      <img ref="decoracionBola2Ref" src="@/assets/bola.avif" class="deco-item lateral-bola-2" alt="Bola" />
    </div>

    <div ref="contenidoRef" class="overlay-content">
      <img ref="ornamentoArriba" src="@/assets/bola.avif" alt="ornamento" class="ornamento-esquina top-left" />

      <div class="header-container">
        <span ref="tituloRef" class="titulo-pase">¡Si estás aquí, no es coincidencia!</span>
        <p ref="subtituloRef" class="subtitulo-pase">Eres alguien muy especial para mí</p>
      </div>
      
      <div ref="textoRef" class="welcome-text-wrapper">
        <div class="linea-decorativa"></div>
        <h2 class="welcome-text" v-html="welcomeTextProcesado"></h2>
        <div class="linea-decorativa"></div>
      </div>

      <div ref="mensajeRef" class="mensaje-bienvenida">
        Quiero festejar contigo mi gran día. Por ello, con muchísima ilusión, 
        he reservado especialmente para ti:
      </div>

      <div class="info-container">
        <div v-if="(paquete === 3 || paquete === 4) && numpase" ref="paseRef" class="info-card pase-card">
          <div class="card-icon">
            <i class="fas fa-ticket-alt"></i>
          </div>
          <div class="card-details">
            <span class="card-label">PASES RESERVADOS</span>
            <span class="card-value">{{ numpase }} {{ numpase === 1 ? 'Lugar' : 'Lugares' }}</span>
          </div>
        </div>

        <div v-if="paquete === 4 && mesaText" ref="mesaRef" class="info-card mesa-card">
          <div class="card-icon">
            <i class="fas fa-chair"></i>
          </div>
          <div class="card-details">
            <span class="card-label">MESA ASIGNADA</span>
            <span class="card-value">{{ mesaText }}</span>
          </div>
        </div>
      </div>

      <p ref="footerTextoRef" class="footer-texto">¡Prepara tus mejores pasos de baile!</p>

      <div ref="lineaDivisoriaRef" class="linea-separadora"></div>

      <div ref="noNinosRef" class="no-ninos-container">
        <div class="no-ninos-badge">
          <i class="fas fa-child-stroke"></i> NO NIÑOS
        </div>
        <p class="no-ninos-texto">
          Hemos decidido que el evento es un ambiente exclusivamente para adultos, esperando que esto no sea impedimento para acompañarme en este día tan importante.
        </p>
      </div>

      <img ref="ornamentoAbajo" src="@/assets/bola.avif" alt="ornamento" class="ornamento-esquina bottom-right" />
    </div>

    <div v-show="showTooltip" ref="tooltipRef" class="tooltip-elegante">
      <i class="fas fa-bell"></i> Por favor, no olvides confirmar tu asistencia
    </div>
  </div>
</template>
<script>
import { ref, onMounted, nextTick, computed, onBeforeUnmount } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import axios from 'axios';
import baseUrl from '@/api';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'InvitadoEvento',
  props: {
    idInvitado: {
      type: Number,
      required: true
    },
    nombre: {
      type: String,
      default: ''
    },
    idFestejado: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const contenidoRef = ref(null);
    const tituloRef = ref(null);
    const subtituloRef = ref(null);
    const textoRef = ref(null);
    const mensajeRef = ref(null);
    const paseRef = ref(null);
    const mesaRef = ref(null);
    const lineaDivisoriaRef = ref(null);
    const noNinosRef = ref(null);
    const footerTextoRef = ref(null);
    const tooltipRef = ref(null);
    const ornamentoArriba = ref(null);
    const ornamentoAbajo = ref(null);

    const decoracionLazoRef = ref(null);
    const decoracionCora1Ref = ref(null);
    const decoracionEstre1Ref = ref(null);
    const decoracionBola1Ref = ref(null);
    const decoracionCora2Ref = ref(null);
    const decoracionEstre2Ref = ref(null);
    const decoracionEstre3Ref = ref(null);
    const decoracionBola2Ref = ref(null);

    const welcomeText = ref('');
    const mesaText = ref('');
    const numpase = ref(null);
    const paquete = ref(null);
    const showTooltip = ref(false);
    
    let ctx;
    let scrollTriggerInstance = null;

    const isValidIdInvitado = computed(() => !isNaN(props.idInvitado) && props.idInvitado > 0);

    const welcomeTextProcesado = computed(() => {
      if (!welcomeText.value) return '';
      return welcomeText.value.replace(/,/g, ',<br />');
    });

    const fetchData = async () => {
      if (isValidIdInvitado.value) {
        try {
          const url = `${baseUrl}/${props.nombre}/${props.idFestejado}/${props.idInvitado}`;
          const response = await axios.get(url);
          welcomeText.value = response.data.nombre_mostrar;
          mesaText.value = response.data.num_mesa;
          numpase.value = response.data.num_pase;
          paquete.value = response.data.paquete;
        } catch (err) {
          console.error('Error al obtener los datos de la invitación', err);
        }
      }
    };

    const animateElements = () => {
      if (ctx) ctx.revert();

      ctx = gsap.context(() => {
        // Configuramos transiciones lineales y suaves (Power2.out), sin rebotes ni saltos
        const tl = gsap.timeline({ defaults: { ease: 'power2.out', duration: 0.8 } });

        // 1. Entrada de la tarjeta blanca central (Fade in + suave deslizamiento)
        tl.fromTo(contenidoRef.value, 
          { opacity: 0, y: 20 }, 
          { opacity: 1, y: 0, duration: 1 }
        );

        // 2. Esquinas internas discretas
        tl.fromTo([ornamentoArriba.value, ornamentoAbajo.value].filter(Boolean),
          { opacity: 0 },
          { opacity: 0.5, duration: 0.8 },
          '-=0.6'
        );

        // 3. Entrada limpia y simultánea de los adornos en las orillas (SIN escalado, solo opacidad)
        const decoraciones = [
          decoracionLazoRef.value, decoracionCora1Ref.value, decoracionEstre1Ref.value, decoracionBola1Ref.value,
          decoracionCora2Ref.value, decoracionEstre2Ref.value, decoracionEstre3Ref.value, decoracionBola2Ref.value
        ].filter(Boolean);

        tl.fromTo(decoraciones,
          { opacity: 0, y: 15 },
          { opacity: 1, y: 0, duration: 1 },
          '-=0.6'
        );

        // 4. Secciones de texto internas
        const textos = [tituloRef.value, subtituloRef.value, textoRef.value, mensajeRef.value].filter(Boolean);
        tl.fromTo(textos,
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0, duration: 0.6 },
          '-=0.6'
        );

        // 5. Tarjetas de información (Pases / Mesa)
        const cards = [paseRef.value, mesaRef.value].filter(Boolean);
        if (cards.length > 0) {
          tl.fromTo(cards,
            { opacity: 0, y: 15 },
            { opacity: 1, y: 0, duration: 0.7 },
            '-=0.4'
          );
        }

        // 6. Pie de tarjeta y cláusula de niños
        if (footerTextoRef.value) tl.fromTo(footerTextoRef.value, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3');
        if (lineaDivisoriaRef.value) tl.fromTo(lineaDivisoriaRef.value, { opacity: 0 }, { opacity: 1, duration: 0.5 }, '-=0.3');
        if (noNinosRef.value) tl.fromTo(noNinosRef.value, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.2');

        // 7. Tooltip de confirmación limpio (Sin brincos ni efectos elásticos)
        if (tooltipRef.value) {
          gsap.fromTo(tooltipRef.value,
            { opacity: 0, y: 10 },
            { opacity: 1, y: 0, duration: 0.8 },
            '-=0.2'
          );
        }

      }, bienvenidaRef.value);
    };

    const resetElements = () => {
      if (ctx) ctx.revert();
    };

    onMounted(async () => {
      await fetchData();
      await nextTick();

      if ((paquete.value === 2 || paquete.value === 3 || paquete.value === 4) && welcomeText.value) {
        scrollTriggerInstance = ScrollTrigger.create({
          trigger: bienvenidaRef.value,
          start: 'top 80%',
          onEnter: () => {
            showTooltip.value = true;
            animateElements();
          },
          onLeaveBack: () => {
            showTooltip.value = false;
            resetElements();
          }
        });
      }
    });

    onBeforeUnmount(() => {
      if (ctx) ctx.revert();
      if (scrollTriggerInstance) scrollTriggerInstance.kill();
    });

    return {
      bienvenidaRef, contenidoRef, tituloRef, subtituloRef, textoRef, mensajeRef,
      paseRef, mesaRef, lineaDivisoriaRef, noNinosRef, footerTextoRef, tooltipRef, 
      ornamentoArriba, ornamentoAbajo, welcomeText, welcomeTextProcesado, mesaText, numpase, paquete, showTooltip,
      decoracionLazoRef, decoracionCora1Ref, decoracionEstre1Ref, decoracionBola1Ref,
      decoracionCora2Ref, decoracionEstre2Ref, decoracionEstre3Ref, decoracionBola2Ref
    };
  }
};
</script>
<style scoped>
/* Contenedor Principal */
.bienvenida-overlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 85vh;
  background-color: #ffffff;
  padding: 60px 20px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* CONTENEDOR DE DECORACIONES COSTRADOS */
.decoraciones-laterales {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1; /* Detrás de la tarjeta blanca */
}

.deco-item {
  position: absolute !important;
  height: auto;
  will-change: transform, opacity;
}

/* ==========================================================
   Coordenadas para Computadora / Pantallas Grandes
   ========================================================== */
.lateral-lazo { top: 12%; left: 4%; width: 80px; transform: rotate(-15deg); }
.lateral-cora-1 { top: 38%; left: 8%; width: 35px; opacity: 0.85; }
.lateral-estre-1 { bottom: 32%; left: 5%; width: 45px; opacity: 0.8; }
.lateral-bola-1 { bottom: 12%; left: 7%; width: 60px; opacity: 0.75; }

.lateral-cora-2 { top: 14%; right: 7%; width: 38px; opacity: 0.85; }
.lateral-estre-2 { top: 34%; right: 4%; width: 50px; opacity: 0.85; }
.lateral-estre-3 { bottom: 40%; right: 8%; width: 40px; opacity: 0.8; }
.lateral-bola-2 { bottom: 15%; right: 5%; width: 65px; opacity: 0.75; }

/* Tarjeta Principal Blanca */
.overlay-content {
  padding: 50px 40px;
  border-radius: 24px;
  text-align: center;
  width: 100%;
  max-width: 480px;
  position: relative;
 
  box-sizing: border-box;
  z-index: 2; /* Por encima de los adornos sueltos */
}

/* Ornamentos de esquinas internas */
.ornamento-esquina {
  position: absolute;
  width: 0px !important;
  height: auto;
  opacity: 0.4;
  pointer-events: none;
}
.ornamento-esquina.top-left { top: 15px; left: 15px; }
.ornamento-esquina.bottom-right {
  bottom: 20px !important;
  right: 20px !important;
  transform: rotate(180deg);
}

/* Textos */
.header-container { margin-bottom: 25px; }
.titulo-pase {
  font-family: 'british', cursive;
  font-size: 32px;
  color: #111111;
  display: block;
  line-height: 1.2;
}
.subtitulo-pase {
  font-family: 'padres', sans-serif;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #444444;
  margin-top: 15px;
  font-weight: 600;
}

.welcome-text-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin: 25px 0;
}
.linea-decorativa {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, #111111, transparent);
}
.welcome-text {
  font-size: 2rem;
  font-family: 'quote', serif;
  color: #111111;
  margin: 0;
  font-weight: 400;
  line-height: 1.3;
}

.mensaje-bienvenida {
  font-size: 1.1rem;
  font-family: 'padres', sans-serif;
  color: #333333;
  line-height: 1.6;
  font-weight: 600;
  margin: 0 auto 30px;
}

/* Contenedores de Pases / Mesa */
.info-container {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: stretch;
  margin-bottom: 30px;
  width: 100%;
}
.info-card {
  background: #fdfdfd;
  border: 1px solid #eaeaea;
  border-radius: 16px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  text-align: left;
}
.card-icon {
  background: #111111;
  color: #ffffff;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}
.card-details { display: flex; flex-direction: column; }
.card-label {
  font-size: 11px;
  font-family: 'padres', sans-serif;
  letter-spacing: 1px;
  color: #666666;
  font-weight: 600;
}
.card-value {
  font-size: 1.1rem;
  font-family: 'quote', serif;
  font-weight: 600;
  color: #111111;
  margin-top: 2px;
}

.footer-texto {
  font-family: 'british', cursive;
  font-size: 24px;
  color: #222222;
  margin: 0 0 10px;
}

.linea-separadora {
  width: 60%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #dddddd, transparent);
  margin: 25px auto;
}

/* Bloque No Niños */
.no-ninos-container {
  border-radius: 16px;
  padding: 20px;
  max-width: 95%;
  margin: 0 auto 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.no-ninos-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'padres', sans-serif;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #555555;
  background-color: #ffffff;
  padding: 4px 14px;
  border-radius: 20px;
  border: 1px solid #e5e5e5;
}
.no-ninos-texto {
  font-family: 'padres', sans-serif;
  font-size: 1.0rem;
  color: #666666;
  line-height: 1.5;
  margin: 0;
}

/* Tooltip Alerta */
.tooltip-elegante {
  margin-top: 25px;
  background: #111111;
  color: #ffffff;
  padding: 10px 24px;
  border-radius: 30px;
  font-size: 12px;
  font-family: 'padres', sans-serif;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 3;
}
.tooltip-elegante i { color: #ffb703; }

/* ==========================================================
   DISEÑO EXCLUSIVO PARA CELULARES (¡Aquí ocurre la magia!)
   ========================================================== */
@media (max-width: 600px) {
  .bienvenida-overlay {
    padding: 30px 15px;
  }

  .overlay-content {
    padding: 35px 20px;
  }

  /* Reposicionamos los adornos para que floten DE DETRÁS de la tarjeta móvil */
  .lateral-lazo { top: -5%; right: -10%; width: 135px; opacity: 0 !important; }
  .lateral-cora-1 { top:0%; left: -15%; width: 128px;}
  .lateral-estre-1 { bottom: -25%; left: 4%; width: 135px !important;opacity: 0 !important;  }
  .lateral-bola-1 { bottom: 7%; left: -14%; width: 145px; }

  .lateral-cora-2 { top: 56%; right: -14%; width: 130px; }
  .lateral-estre-2 { top: 26%; right: 3%; width: 40px;opacity: 0 !important; }
  .lateral-estre-3 { bottom: 28%; right: 6%; width: 32px; }
  .lateral-bola-2 { bottom: 6%; right: 3%; width: 50px; opacity: 0 !important;}
  
  .info-container {
    flex-direction: column; /* Tarjetas de pases una arriba de la otra */
    gap: 12px;
  }

  .welcome-text {
    font-size: 1.6rem;
  }
}
</style>